module.exports = __webpack_public_path__ + "static/media/golfer-3-b.8892fa99.png";